import { render } from "./DataSecurityView.vue?vue&type=template&id=13d0d0aa"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__